import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { ContactPageView } from '@/components/pages/contact/ContactPageView';
import Layout from '@/container/Layout';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { contactPath, getAbsolutePath } from '@/utils/router/links';
const title = '各種お問い合わせ | PROFFIT';
const description = 'PROFFITはコンサル選定支援サービスです。累計80億円以上のコンサル相談実績があり、500社以上のコンサルティング会社から依頼内容や費用水準に合わせて最適なコンサルチームを選定することが出来ます。';
/**
 * お問合せ: 各種お問合せページ
 * @param props
 * @constructor
 */
export const ContactPage = () => (_jsxs(Layout, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(contactPath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(ContactPageView, { className: 'mt-60 lg:mt-80' })] }));
